export default __webpack_public_path__ + "assets/front/scss/collaborative-indexation.ce1449dc81325d52ce94129c4fef794c.css";